import React, { useState, useEffect, useContext } from 'react';
import {
    Modal,
    Box,
    Typography,
    TextField,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Switch,
    Button,
    IconButton,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import useApiManager from '../../utils/Api/apiManager';
import { toast } from 'sonner';

const InviteUser = ({ open, onClose, fetchLeadTasks }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState(null);
    const [role, setRole] = useState(1);
    const [externalId, setExternalId] = useState('');

    const { post } = useApiManager();

    const handleSave = async (event) => {
        event.preventDefault();
        const formData = {
            firstName,
            lastName,
            email,
            role,
            externalId
        };

        try {
            const responseData = await post('/invitations', formData);
            toast.success("Invitation sent successfully!")
            onClose();
            fetchLeadTasks();
            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    }

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">Invite User</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider sx={{ my: 2 }} />
                <form id='invite-user' onSubmit={handleSave}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            required
                            label="First Name"
                            variant="outlined"
                            sx={{ mb: 2, flex: 1 }}  // Ensure equal weight
                            onChange={(e) => setFirstName(e.target.value)}
                            value={firstName}
                        />

                        <TextField
                            label="Last Name"
                            variant="outlined"
                            sx={{ mb: 2, flex: 1 }}  // Ensure equal weight
                            onChange={(e) => setLastName(e.target.value)}
                            value={lastName}
                        />
                    </Box>


                    <TextField
                        fullWidth
                        required
                        label="Email"
                        variant="outlined"
                        sx={{ mb: 2 }}
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                    />
                    <TextField
                        fullWidth
                        label="External Id"
                        variant="outlined"
                        sx={{ mb: 2 }}
                        onChange={(e) => setExternalId(e.target.value)}
                        value={externalId}
                    />

                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Role</InputLabel>
                        <Select
                            required
                            label="Role"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <MenuItem value={1}>User</MenuItem>
                            <MenuItem value={2}>Manager</MenuItem>
                            <MenuItem value={0}>Admin</MenuItem>
                            <MenuItem value={4}>ID User</MenuItem>
                        </Select>
                    </FormControl>

                </form>
                <Box sx={{ mt: 2, textAlign: 'right' }}>
                    <Button onClick={onClose} sx={{ mr: 2 }}>Cancel</Button>
                    <Button type="submit" form="invite-user" variant="contained" color="primary">Submit</Button>
                </Box>
            </Box>
        </Modal>
    );
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 1,
    boxShadow: 24,
    p: 4,
};

export default InviteUser;
